import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Получите отчёт по оценке полей на основе спутниковых данных',
  subtitle: 'Вам доступно до 5 отчетов',
  comment: 'Заявка на отчет из раздела "Кредиты и лизинг"',
  action: 'Получить отчет',
} satisfies TMessages
